import React, { PureComponent } from "react";
import axios from "axios";
import { server, RECAPTCHA_KEY } from "../env";
import { Link } from "react-router-dom";

// helper components
import Loader from "../components/Loader";
import Recaptcha from "react-google-invisible-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class ForgotPassword extends PureComponent {
  state = {};

  notify = (message, type) => {
    toast(message, { type, theme: "colored" });
  };

  forgot = async (e) => {
    e.preventDefault();

    this.setState({
      loader: <Loader />,
    });

    await this.recaptcha.execute();

    localStorage.setItem("email", e.target.email.value);

    const params = {
      email: e.target.email.value,
      "g-recaptcha-response": this.state.reCaptcha,
    };

    await axios
      .post(server + "/v1/auth/forgot-password", params)
      .then((rsp) => {
        this.notify(rsp.data.detail, "success");

        this.setState({
          loader: "",
        });
        window.location.href = "/reset";
      })
      .catch((err) => {
        if (err.response) {
          this.notify(err.response.data.detail, "error");
        }
        this.setState({
          loader: "",
        });
      });
  };

  onResolved = () => {
    this.setState({ reCaptcha: this.recaptcha.getResponse() });
  };

  render() {
    const { loader } = this.state;

    return (
      <section className="login_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="notification_wrap error_wrap"></div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="signup_inner_wrap">
                <div className="signup_frm_wrap">
                  <form onSubmit={this.forgot}>
                    <h6>Forgot Password?</h6>
                    <p>
                      Enter your registered email address <br />
                      to reset your password
                    </p>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                        name="email"
                        autoFocus
                        required
                      />
                      <i className="fa fa-key"></i>
                    </div>

                    <div className="form-group ">
                      <button type="submit" className="btn btn_submit">
                        Submit {loader}
                      </button>
                    </div>
                    <div className="form-group mb-0">
                      <p>
                        Remember password? <Link to="/login">Login</Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={RECAPTCHA_KEY}
          onResolved={this.onResolved}
        />
      </section>
    );
  }
}

export default ForgotPassword;
